import React from "react";
import icon from "./current-page.svg";

export const CurrentPageIcon = () => {
    return (
        <img alt={"current page icon"} aria-hidden={true} className={"current-page-icon"} src={icon}/>
    );
};
